import React, { FC } from 'react';

import { DefaultDailyBonus, ProductData } from '@appcharge/shared-ui';

import useOffersUI from 'api/useOffersUI';
import { OfferPreviewShell } from 'views/Offers/components/OfferPreviewShell';
import { IResolvedProgressBarMission } from 'views/Offers/utils/resolveProgressBarPoints';
import { POPUP_CONTAINER_STYLE } from 'views/OfferDesign/pages/OfferDesignForm/components/OfferDesignPreview/OfferDesignPreview.consts';

const PREVIEW_CONTAINER_ID = 'popup-preview';

interface IDailyBonusPreviewProps {
  publisherId?: string;
  currentOfferUI: string;
  previewProducts: ProductData[];
  progressBarPoints?: IResolvedProgressBarMission[];
}

export const DailyBonusPreview: FC<IDailyBonusPreviewProps> = ({
  publisherId,
  currentOfferUI,
  previewProducts,
  progressBarPoints
}): React.ReactElement => {
  const { getOfferUI } = useOffersUI(publisherId, currentOfferUI);
  const offerData = getOfferUI?.data;

  return (
    <OfferPreviewShell
      containerId={PREVIEW_CONTAINER_ID}
      containerStyle={POPUP_CONTAINER_STYLE}
    >
      {() => (
        <DefaultDailyBonus
          isPreview
          title={offerData?.specialOffer?.title || ''}
          titleColor={offerData?.specialOffer?.fontColor?.colorOne}
          titleWeight={offerData?.specialOffer?.fontWeight}
          titleSize={offerData?.specialOffer?.fontSize?.toString()}
          borderWidth={offerData?.borderWidth}
          borderColor={offerData?.borderColor}
          modalContainer={() => document.getElementById(PREVIEW_CONTAINER_ID)}
          backgroundImage={offerData?.backgroundImage}
          products={previewProducts}
          onCollect={async () => true}
          onClose={() => {}}
          onAnimationSuccessEndNoPreview={() => {}}
          progressBarPoints={progressBarPoints}
        />
      )}
    </OfferPreviewShell>
  );
};
